import { render, staticRenderFns } from "./adminTools.vue?vue&type=template&id=7f18cbb3&"
import script from "./adminTools.vue?vue&type=script&lang=js&"
export * from "./adminTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports